import './styles.scss'
import React    from 'react'

import FileItem   from './file-item'
import EmptyState from '../../Shared/EmptyState/index'

export default ({ files, on_cancel, on_click}) => (
  <div className={'files'}>
    {
      ((!files || files.length === 0) ?
        <EmptyState title={'No Ongoing Encoding'}
                    on_click={on_click}/> :
        (files.map((file, index) =>
            <FileItem key        = {index}
                      file       = {file}
                      on_cancel  = {on_cancel}
            />)
        ))
    }
  </div>
)
